import apiTrainers from '@/api/trainers'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  createTrainerStart: '[create trainer] Create trainer start',
  createTrainerSuccess: '[create trainer] Create trainer success',
  createTrainerFailure: '[create trainer] Create trainer failure'
}

export const actionTypes = {
  createTrainer: '[create trainer] Create trainer'
}

const mutations = {
  [mutationTypes.createTrainerStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createTrainerSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createTrainerFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.createTrainer](context, {trainer}) {
    context.commit(mutationTypes.createTrainerStart)
    return new Promise(resolve => {
      apiTrainers
        .createTrainer(trainer)
        .then(response => {
          context.commit(mutationTypes.createTrainerSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.createTrainerFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
